// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Sticky_spacer__QvR9V","fixed":"Sticky_fixed__A5irG","fadeInDown":"Sticky_fadeInDown__CdmGh"};